<template>
  <section>
    <div class="row">
      <div class="col-lg-4">
        <div class="widget style1 navy-bg">
          <div class="row">
            <div class="col-xs-4">
              <i class="fa fa-shopping-cart fa-5x"></i>
            </div>
            <div class="col-xs-8 text-right">
              <span> Total Invoices </span>
              <h2 class="font-bold">{{InvoiceStats.total_invoices}}</h2>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="widget style1 red-bg">
          <div class="row">
            <div class="col-xs-4">
              <i class="fa fa-cart-arrow-down fa-5x"></i>
            </div>
            <div class="col-xs-8 text-right">
              <span>Total Pending Invoices</span>
              <h2 class="font-bold">{{InvoiceStats.pending_status}}</h2>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="widget style1 lazur-bg">
          <div class="row">
            <div class="col-xs-4">
              <i class="fa fa-money fa-5x"></i>
            </div>
            <div class="col-xs-8 text-right">
              <span>Total Revenue</span>
              <h2 class="font-bold">{{(InvoiceStats.total_revenue !== undefined)? InvoiceStats.total_revenue.toFixed(2) : 0.0}}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
export default {
  data(){
    return{
      InvoiceStats: {},
    }
  },
  mounted() {
    this.$http.get(this.$store.state.mainAppURL + "billings/get_subscription_invoices_stats").then((resp) =>{
      this.InvoiceStats = resp.data;
    })
  }
}
</script>